export const MOBILE_APP_PAGE_SLUG = 'mobile-app'

export interface Page {
  token: string
  slug: string
  icon: string
  language: string
  order: number
  menutitle: string
  content: string
  lastupdated: number
}
